export const GET_EVALUATION_REPORT_CONFIG =
  "labelingEvaluationReport/GET_EVALUATION_REPORT_CONFIG";
export const CREATE_EVALUATION_REPORT_EXPORT =
  "labelingEvaluationReport/CREATE_EVALUATION_REPORT_EXPORT";
export const GET_EVALUATION_REPORT_EXPORTS =
  "labelingEvaluationReport/GET_EVALUATION_REPORT_EXPORTS";
export const RE_EXPORT_EVALUATION_REPORT =
  "labelingEvaluationReport/RE_EXPORT_EVALUATION_REPORT";

export const getEvaluationReportConfig = (payload) => ({
  type: GET_EVALUATION_REPORT_CONFIG,
  payload,
});

export const createEvaluationReportExport = (payload) => ({
  type: CREATE_EVALUATION_REPORT_EXPORT,
  payload,
});

export const getEvaluationReportExports = (payload) => ({
  type: GET_EVALUATION_REPORT_EXPORTS,
  payload,
});

export const reExportEvaluationReport = (payload) => ({
  type: RE_EXPORT_EVALUATION_REPORT,
  payload,
});
